/* C'est du Joly — quantite, metrage, sous-total des options et total general. */
(function () {
  'use strict';

  if (window.__cdjProductPurchaseInitialized) return;
  window.__cdjProductPurchaseInitialized = true;

  var TOTAL_SELECTOR = '[data-cdj-quantity-total]';
  var SUMMARY_SELECTOR = '[data-cdj-selection-summary]';
  var QUANTITY_SELECTOR = '[data-quantity-value][name="quantity"]';
  var UPSELL_OPTION_SELECTOR = '[data-cdj-upsell-option]';
  var UPSELL_CHECKBOX_SELECTOR = '[data-cdj-upsell-checkbox]';
  var FABRIC_LENGTH_SELECTOR = '[data-cdj-fabric-length]';
  var SHRINKAGE_SELECTOR = '[data-cdj-shrinkage]';
  var COUPON_TITLE_MARKER = /(?:joly\s+coupons?|coupon(?:s)?|fin\s+de\s+rouleau|reste\s+de\s+rouleau|fabric\s+cut|remnant|end\s+of\s+(?:the\s+)?roll|stofcoupon|reststuk|einde\s+van\s+de\s+rol|rolrest|stoffcoupon|stoffrest|reststück|rollenende|retal|fin\s+de\s+rollo|retalho|fim\s+de\s+rolo|scampolo|fine\s+rotolo|longueur|length|lengte|länge|longitud|comprimento|lunghezza)/i;
  var observer = null;

  function toInteger(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  }

  function formatMoney(cents) {
    if (
      window.T4SThemeSP &&
      window.T4SThemeSP.Currency &&
      typeof window.T4SThemeSP.Currency.formatMoney === 'function'
    ) {
      return window.T4SThemeSP.Currency.formatMoney(cents);
    }

    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.T4Sconfigs && window.T4Sconfigs.cartCurrency) ||
      'EUR';
    var locale = document.documentElement.lang || 'fr-FR';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function getProductForm(totalElement) {
    if (!totalElement) return null;

    var directForm = totalElement.closest('form[data-type="add-to-cart-form"], form');
    if (directForm) return directForm;

    var productRoot = totalElement.closest('[data-product-featured], .t4s-product__info-wrapper, [data-t4s-zoom-info]');
    if (productRoot) {
      var rootForm = productRoot.querySelector('form[data-type="add-to-cart-form"]');
      if (rootForm) return rootForm;
    }

    var productId = totalElement.getAttribute('data-product-id');
    if (productId) {
      return (
        document.querySelector('form.is--main-sticky[data-productid="' + productId + '"][data-type="add-to-cart-form"]') ||
        document.querySelector('form[data-productid="' + productId + '"][data-type="add-to-cart-form"]')
      );
    }

    return null;
  }

  function getQuantityInput(totalElement) {
    var form = getProductForm(totalElement);
    return form ? form.querySelector(QUANTITY_SELECTOR) : null;
  }

  function getUpsellTotals(totalElement) {
    var form = getProductForm(totalElement);
    var totals = { final: 0, compare: 0, selectedCount: 0 };
    if (!form) return totals;

    form.querySelectorAll(UPSELL_OPTION_SELECTOR).forEach(function (option) {
      var checkbox = option.querySelector(UPSELL_CHECKBOX_SELECTOR);
      if (!checkbox || !checkbox.checked || checkbox.disabled || option.dataset.state === 'unavailable') return;

      var quantity = Math.max(1, toInteger(option.dataset.quantity, 1));
      var price = Math.max(0, toInteger(option.dataset.price, 0));
      var comparePrice = Math.max(price, toInteger(option.dataset.comparePrice, price));

      totals.selectedCount += 1;
      totals.final += price * quantity;
      totals.compare += comparePrice * quantity;
    });

    return totals;
  }

  function setLegacyTotalVisibility(totalElement, shouldShow) {
    totalElement.hidden = !shouldShow;
    totalElement.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    totalElement.style.setProperty('display', shouldShow ? 'inline-flex' : 'none', 'important');
  }

  function setSummaryVisibility(summary, shouldShow) {
    summary.hidden = !shouldShow;
    summary.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    summary.style.removeProperty('display');
  }

  function setMoney(element, cents) {
    if (element) element.innerHTML = formatMoney(cents);
  }

  function setCompareMoney(element, compareCents, finalCents) {
    if (!element) return;
    var show = compareCents > finalCents;
    element.hidden = !show;
    if (show) element.innerHTML = formatMoney(compareCents);
  }

  function toPositiveNumber(value) {
    var number = Number(String(value || '').replace(',', '.'));
    return Number.isFinite(number) && number > 0 ? number : 0;
  }

  function measurementToCentimeters(major, unit, minor) {
    var first = toPositiveNumber(major);
    if (!first) return 0;

    if (String(unit || '').toLowerCase().indexOf('m') === 0 && String(unit || '').toLowerCase() !== 'mm') {
      var extra = Math.max(0, toInteger(minor, 0));
      return Math.round(first * 100 + extra);
    }

    return Math.round(first);
  }

  function hasWidthContext(title, start, end) {
    var before = title.slice(Math.max(0, start - 28), start);
    var after = title.slice(end, Math.min(title.length, end + 22));
    var beforeWidth = /(?:laize|largeur|large de|width|wide|breite|stoffbreite|ancho|larghezza|largura|gsm|g\/m)\s*(?:de|:|-)?\s*$/i;
    var afterWidth = /^\s*(?:de\s+)?(?:laize|large|wide|width|breite|stoffbreite|ancho|larghezza|largura|gsm|g\/m)/i;
    var dimensionBefore = /\d+(?:[.,]\d+)?\s*(?:cm|m)?\s*[x×]\s*$/i;
    var dimensionAfter = /^\s*[x×]\s*\d/i;
    return beforeWidth.test(before) || afterWidth.test(after) || dimensionBefore.test(before) || dimensionAfter.test(after);
  }

  function hasCouponContext(title, start, end) {
    var before = title.slice(Math.max(0, start - 48), start);
    var after = title.slice(end, Math.min(title.length, end + 38));
    return COUPON_TITLE_MARKER.test(before) || COUPON_TITLE_MARKER.test(after);
  }

  function parseCouponLength(titleValue) {
    var title = String(titleValue || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();

    if (!title || !COUPON_TITLE_MARKER.test(title)) return 0;

    var measurements = [];
    var compactMeters = /\b(\d{1,2})\s*m\s*(\d{1,2})\b/gi;
    var regularUnits = /\b(\d+(?:[.,]\d+)?)\s*(cm|m(?:e|è)tres?|m)\b/gi;
    var match;

    while ((match = compactMeters.exec(title)) !== null) {
      if (hasWidthContext(title, match.index, compactMeters.lastIndex)) continue;
      measurements.push({
        centimeters: measurementToCentimeters(match[1], 'm', match[2]),
        start: match.index,
        end: compactMeters.lastIndex,
        meterBased: true
      });
    }

    while ((match = regularUnits.exec(title)) !== null) {
      var overlapsExisting = measurements.some(function (measurement) {
        return match.index >= measurement.start && match.index < measurement.end;
      });
      if (overlapsExisting || hasWidthContext(title, match.index, regularUnits.lastIndex)) continue;

      var unit = String(match[2] || '').toLowerCase();
      measurements.push({
        centimeters: unit === 'cm' ? measurementToCentimeters(match[1], 'cm') : measurementToCentimeters(match[1], 'm'),
        start: match.index,
        end: regularUnits.lastIndex,
        meterBased: unit !== 'cm'
      });
    }

    measurements = measurements.filter(function (measurement) {
      return measurement.centimeters >= 20 && measurement.centimeters <= 2000 && hasCouponContext(title, measurement.start, measurement.end);
    });

    if (measurements.length === 1) return measurements[0].centimeters;

    var meterMeasurements = measurements.filter(function (measurement) {
      return measurement.meterBased;
    });
    if (meterMeasurements.length === 1) return meterMeasurements[0].centimeters;

    return 0;
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = String(value);
  }

  function calculateShrinkage(currentValue, percentageValue, stepValue) {
    var currentCentimeters = Math.max(0, toInteger(currentValue, 0));
    var percentage = Math.min(99, Math.max(1, toInteger(percentageValue, 10)));
    var stepCentimeters = Math.max(1, toInteger(stepValue, 10));
    if (!currentCentimeters) return null;

    var afterWashCentimeters = Math.floor(currentCentimeters * (100 - percentage) / 100);
    var requiredCentimeters = Math.ceil(currentCentimeters / (1 - percentage / 100));
    var recommendedCentimeters = Math.ceil(requiredCentimeters / stepCentimeters) * stepCentimeters;

    return {
      current: currentCentimeters,
      after: afterWashCentimeters,
      percentage: percentage,
      recommended: recommendedCentimeters
    };
  }

  function resolveShrinkageLength(modeValue, quantityValue, unitValue, fixedValue, parsedValue, titleValue) {
    var mode = String(modeValue || 'none');

    if (mode === 'quantity') {
      var unitCentimeters = Math.max(1, toInteger(unitValue, 10));
      return Math.max(1, toInteger(quantityValue, 1)) * unitCentimeters;
    }

    if (mode === 'fixed') {
      // Chaque Joly Coupon est une pièce indivisible de 300 cm : la quantité additionne les coupons entiers.
      return Math.max(1, toInteger(quantityValue, 1)) * Math.max(0, toInteger(fixedValue, 0));
    }

    if (mode === 'title') {
      var parsedCentimeters = Math.max(0, toInteger(parsedValue, 0));
      return parsedCentimeters || parseCouponLength(titleValue || '');
    }

    return 0;
  }

  function calculateRecommendedCouponCount(currentValue, percentageValue, fixedValue) {
    var currentCentimeters = Math.max(0, toInteger(currentValue, 0));
    var percentage = Math.min(99, Math.max(1, toInteger(percentageValue, 10)));
    var fixedCentimeters = Math.max(1, toInteger(fixedValue, 300));
    if (!currentCentimeters) return 0;

    var retainedPercentage = 100 - percentage;
    var requiredCentimeters = Math.ceil(currentCentimeters * 100 / retainedPercentage);
    return Math.ceil(requiredCentimeters / fixedCentimeters);
  }

  function updateShrinkage(lengthBox, quantity) {
    var shrinkage = lengthBox.querySelector(SHRINKAGE_SELECTOR);
    if (!shrinkage) return;

    var mode = shrinkage.dataset.lengthMode || 'none';
    var percentage = Math.min(99, Math.max(1, toInteger(shrinkage.dataset.percentage, 10)));
    var stepCentimeters = Math.max(1, toInteger(shrinkage.dataset.stepCentimeters, 10));
    var currentCentimeters = resolveShrinkageLength(
      mode,
      quantity,
      lengthBox.dataset.unitCentimeters,
      shrinkage.dataset.fixedCentimeters,
      shrinkage.dataset.parsedCentimeters,
      shrinkage.dataset.productTitle
    );

    if (mode === 'title' && currentCentimeters && !shrinkage.dataset.parsedCentimeters) {
      shrinkage.dataset.parsedCentimeters = String(currentCentimeters);
    }

    var measurement = shrinkage.querySelector('[data-cdj-shrinkage-measurement]');
    var generic = shrinkage.querySelector('[data-cdj-shrinkage-generic]');

    if (!currentCentimeters) {
      if (measurement) measurement.hidden = true;
      if (generic) generic.hidden = false;
      return;
    }

    var calculation = calculateShrinkage(currentCentimeters, percentage, stepCentimeters);
    if (!calculation) return;

    setText(shrinkage, '[data-cdj-shrinkage-current]', calculation.current);
    setText(shrinkage, '[data-cdj-shrinkage-after]', calculation.after);
    setText(shrinkage, '[data-cdj-shrinkage-percentage]', calculation.percentage);
    setText(shrinkage, '[data-cdj-shrinkage-target]', calculation.current);
    setText(shrinkage, '[data-cdj-shrinkage-recommended]', calculation.recommended);

    if (mode === 'fixed') {
      var fixedCentimeters = Math.max(1, toInteger(shrinkage.dataset.fixedCentimeters, 300));
      var recommendedCoupons = calculateRecommendedCouponCount(
        calculation.current,
        calculation.percentage,
        fixedCentimeters
      );

      setText(shrinkage, '[data-cdj-shrinkage-target-meters]', calculation.current / 100);
      setText(shrinkage, '[data-cdj-shrinkage-recommended-coupons]', recommendedCoupons);
    }

    if (measurement) measurement.hidden = false;
    if (generic) generic.hidden = true;
  }

  function updateFabricLength(form, quantity) {
    if (!form) return;

    form.querySelectorAll(FABRIC_LENGTH_SELECTOR).forEach(function (lengthBox) {
      var unitCentimeters = Math.max(1, toInteger(lengthBox.dataset.unitCentimeters, 10));
      var value = lengthBox.querySelector('[data-cdj-fabric-length-value]');
      if (value) value.textContent = String(quantity * unitCentimeters);
      updateShrinkage(lengthBox, quantity);
    });
  }

  function renderSummary(summary, quantityOverride) {
    var quantityInput = getQuantityInput(summary);
    var form = getProductForm(summary);

    if (!quantityInput || !form) {
      setSummaryVisibility(summary, false);
      return;
    }

    var quantity = Math.max(
      1,
      toInteger(quantityOverride !== undefined ? quantityOverride : quantityInput.value, 1)
    );
    var unitPrice = Math.max(0, toInteger(summary.dataset.unitPrice, 0));
    var comparePrice = Math.max(unitPrice, toInteger(summary.dataset.comparePrice, unitPrice));
    var variantSelected = summary.dataset.variantSelected !== 'false';
    var productFinal = unitPrice * quantity;
    var productCompare = comparePrice * quantity;
    var upsellTotals = getUpsellTotals(summary);
    var grandFinal = productFinal + upsellTotals.final;
    var grandCompare = productCompare + upsellTotals.compare;

    setMoney(summary.querySelector('[data-cdj-summary-product-final]'), productFinal);
    setCompareMoney(summary.querySelector('[data-cdj-summary-product-compare]'), productCompare, productFinal);

    var optionsRow = summary.querySelector('[data-cdj-summary-options-row]');
    if (optionsRow) optionsRow.hidden = upsellTotals.selectedCount === 0;
    setMoney(summary.querySelector('[data-cdj-summary-options-final]'), upsellTotals.final);
    setCompareMoney(summary.querySelector('[data-cdj-summary-options-compare]'), upsellTotals.compare, upsellTotals.final);

    setMoney(summary.querySelector('[data-cdj-quantity-total-final]'), grandFinal);
    setCompareMoney(summary.querySelector('[data-cdj-quantity-total-compare]'), grandCompare, grandFinal);

    var fabricUnitCentimeters = Math.max(0, toInteger(summary.dataset.fabricUnitCentimeters, 0));
    var measureElement = summary.querySelector('[data-cdj-summary-product-measure]');
    var quantityElement = summary.querySelector('[data-cdj-summary-product-quantity]');
    if (measureElement && fabricUnitCentimeters > 0) {
      measureElement.textContent = String(quantity * fabricUnitCentimeters);
    }
    if (quantityElement) quantityElement.textContent = String(quantity);

    updateFabricLength(form, quantity);
    setSummaryVisibility(summary, variantSelected);
  }

  function renderLegacyTotal(totalElement, quantityOverride) {
    var quantityInput = getQuantityInput(totalElement);
    if (!quantityInput) {
      setLegacyTotalVisibility(totalElement, false);
      return;
    }

    var quantity = Math.max(
      1,
      toInteger(quantityOverride !== undefined ? quantityOverride : quantityInput.value, 1)
    );
    var unitPrice = Math.max(0, toInteger(totalElement.dataset.unitPrice, 0));
    var comparePrice = Math.max(unitPrice, toInteger(totalElement.dataset.comparePrice, unitPrice));
    var variantSelected = totalElement.dataset.variantSelected !== 'false';
    var upsellTotals = getUpsellTotals(totalElement);
    var finalTotal = unitPrice * quantity + upsellTotals.final;
    var compareTotal = comparePrice * quantity + upsellTotals.compare;

    setMoney(totalElement.querySelector('[data-cdj-quantity-total-final]'), finalTotal);
    setCompareMoney(totalElement.querySelector('[data-cdj-quantity-total-compare]'), compareTotal, finalTotal);
    updateFabricLength(getProductForm(totalElement), quantity);
    setLegacyTotalVisibility(totalElement, variantSelected && finalTotal >= 0);
  }

  function renderTotal(totalElement, quantityOverride) {
    if (!totalElement) return;
    if (totalElement.matches(SUMMARY_SELECTOR)) {
      renderSummary(totalElement, quantityOverride);
    } else {
      renderLegacyTotal(totalElement, quantityOverride);
    }
  }

  function renderTotalsWithin(root, quantityOverride) {
    if (!root || !root.querySelectorAll) return;

    if (root.matches && root.matches(TOTAL_SELECTOR)) {
      renderTotal(root, quantityOverride);
    }

    root.querySelectorAll(TOTAL_SELECTOR).forEach(function (totalElement) {
      renderTotal(totalElement, quantityOverride);
    });
  }

  function getMainTotalElement() {
    return (
      document.querySelector('form.t4s-form__product.is--main-sticky ' + SUMMARY_SELECTOR) ||
      document.querySelector(SUMMARY_SELECTOR) ||
      document.querySelector('form.t4s-form__product.is--main-sticky ' + TOTAL_SELECTOR) ||
      document.querySelector(TOTAL_SELECTOR)
    );
  }

  function renderStickyTotal(forceCaptureUnitPrice) {
    var sticky = document.querySelector('[data-sticky-addtocart]');
    var source = getMainTotalElement();
    if (!sticky || !source) return;

    var quantityInput = sticky.querySelector('[data-quantity-value]');
    var priceElement = sticky.querySelector('[data-sticky-price]');
    if (!quantityInput || !priceElement) return;

    var quantity = Math.max(1, toInteger(quantityInput.value, 1));
    var unitPrice = Math.max(0, toInteger(source.dataset.unitPrice, 0));
    var comparePrice = Math.max(unitPrice, toInteger(source.dataset.comparePrice, unitPrice));
    var upsellTotals = getUpsellTotals(source);
    var finalTotal = unitPrice * quantity + upsellTotals.final;
    var compareTotal = comparePrice * quantity + upsellTotals.compare;
    var containsGeneratedTotal = !!priceElement.querySelector('[data-cdj-sticky-total-value]');

    if (!priceElement.dataset.cdjUnitPriceHtml || (!containsGeneratedTotal && forceCaptureUnitPrice)) {
      priceElement.dataset.cdjUnitPriceHtml = priceElement.innerHTML;
    } else if (!containsGeneratedTotal) {
      priceElement.dataset.cdjUnitPriceHtml = priceElement.innerHTML;
    }

    if ((quantity <= 1 && upsellTotals.selectedCount === 0) || unitPrice < 0) {
      if (priceElement.dataset.cdjUnitPriceHtml) {
        priceElement.innerHTML = priceElement.dataset.cdjUnitPriceHtml;
      }
      return;
    }

    var labelElement = source.querySelector('[data-cdj-summary-grand-label], .cdj-quantity-total__label');
    var label = labelElement ? labelElement.textContent.trim() : 'Total';
    var priceHtml = '<span class="cdj-sticky-total-label">' + label + '</span>';

    if (compareTotal > finalTotal) {
      priceHtml += '<del>' + formatMoney(compareTotal) + '</del> ';
      priceHtml += '<ins data-cdj-sticky-total-value>' + formatMoney(finalTotal) + '</ins>';
    } else {
      priceHtml += '<span data-cdj-sticky-total-value>' + formatMoney(finalTotal) + '</span>';
    }

    priceElement.innerHTML = priceHtml;
  }

  function renderFromUpsellTarget(target) {
    var form = target && target.closest ? target.closest('form[data-type="add-to-cart-form"], form') : null;
    if (form) {
      renderTotalsWithin(form);
      var productRoot = form.closest('[data-product-featured], .t4s-product__info-wrapper, [data-t4s-zoom-info]');
      if (productRoot) renderTotalsWithin(productRoot);
    } else {
      renderTotalsWithin(document);
    }

    window.requestAnimationFrame(function () {
      renderStickyTotal(false);
    });
  }

  function renderFromQuantityTarget(target, quantityOverride) {
    if (!target) return;

    var form = target.closest('form[data-type="add-to-cart-form"], form');
    var sticky = target.closest('[data-sticky-addtocart]');

    if (form) {
      renderTotalsWithin(form, quantityOverride);

      var productRoot = form.closest('[data-product-featured], .t4s-product__info-wrapper, [data-t4s-zoom-info]');
      if (productRoot) {
        renderTotalsWithin(productRoot, quantityOverride);
      } else if (form.dataset.productid) {
        document.querySelectorAll(TOTAL_SELECTOR + '[data-product-id="' + form.dataset.productid + '"]').forEach(function (totalElement) {
          renderTotal(totalElement, quantityOverride);
        });
      }
    }

    if (sticky) {
      var mainTotal = getMainTotalElement();
      if (mainTotal) renderTotal(mainTotal, quantityOverride);
    }

    window.requestAnimationFrame(function () {
      renderStickyTotal(false);
    });
  }

  function extractVariant(event) {
    return (
      event.currentVariant ||
      (event.detail && (event.detail.currentVariant || event.detail.variant)) ||
      (event.originalEvent && event.originalEvent.detail && (event.originalEvent.detail.currentVariant || event.originalEvent.detail.variant)) ||
      null
    );
  }

  function handleVariantChanged(event) {
    var variant = extractVariant(event);
    if (!variant) return;

    document.querySelectorAll(TOTAL_SELECTOR).forEach(function (totalElement) {
      var form = getProductForm(totalElement);
      var variantInput = form ? form.querySelector('[name="id"]') : null;
      var matchesVariant = variantInput && String(variantInput.value) === String(variant.id);
      var eventTarget = event.target && event.target.nodeType === 1 ? event.target : null;
      var eventRoot = eventTarget && eventTarget.closest
        ? eventTarget.closest('[data-product-featured], .t4s-product__info-wrapper, [data-t4s-zoom-info]')
        : null;
      var belongsToEventRoot = eventRoot && eventRoot.contains(totalElement);
      var productMatches = variant.product_id && String(totalElement.dataset.productId) === String(variant.product_id);

      if (!matchesVariant && !belongsToEventRoot && !productMatches) return;

      totalElement.dataset.unitPrice = String(variant.price || 0);
      totalElement.dataset.comparePrice = String(variant.compare_at_price || variant.price || 0);
      totalElement.dataset.variantSelected = 'true';
      renderTotal(totalElement);
    });

    window.setTimeout(function () {
      renderStickyTotal(true);
    }, 0);
    window.setTimeout(function () {
      renderStickyTotal(true);
    }, 80);
  }

  function initialize() {
    renderTotalsWithin(document);
    renderStickyTotal(true);
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches(QUANTITY_SELECTOR)) {
      renderFromQuantityTarget(event.target);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-quantity-value]')) {
      renderFromQuantityTarget(event.target);
    } else if (event.target.matches(UPSELL_CHECKBOX_SELECTOR)) {
      renderFromUpsellTarget(event.target);
    }
  });

  document.addEventListener('cdj:upsell-price-updated', function (event) {
    renderFromUpsellTarget(event.target);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-selector]');
    if (!button) return;

    var wrapper = button.closest('[data-quantity-wrapper]');
    var input = wrapper ? wrapper.querySelector('[data-quantity-value]') : null;
    if (!input) return;

    var current = Math.max(1, toInteger(input.value, 1));
    var step = Math.max(1, toInteger(input.getAttribute('step'), 1));
    var minimum = Math.max(1, toInteger(input.getAttribute('min'), 1));
    var maximum = toInteger(input.getAttribute('max'), Number.MAX_SAFE_INTEGER);
    var expected = button.hasAttribute('data-decrease-qty')
      ? Math.max(minimum, current - step)
      : Math.min(maximum, current + step);

    renderFromQuantityTarget(input, expected);

    window.requestAnimationFrame(function () {
      renderFromQuantityTarget(input, expected);
    });
    window.setTimeout(function () {
      renderFromQuantityTarget(input);
    }, 60);
    window.setTimeout(function () {
      renderFromQuantityTarget(input);
    }, 180);
  });

  document.addEventListener('variant:changed', handleVariantChanged);
  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('variant:changed.cdjProductPurchase', handleVariantChanged);
  }

  observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) renderTotalsWithin(node);
      });
    });
  });

  function start() {
    initialize();
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }

  window.CDJProductPurchase = {
    refresh: initialize,
    render: renderTotalsWithin,
    parseCouponLength: parseCouponLength,
    calculateShrinkage: calculateShrinkage,
    resolveShrinkageLength: resolveShrinkageLength,
    calculateRecommendedCouponCount: calculateRecommendedCouponCount
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
